const siderBar = {
  profile: "Perfil",
  history: "Historial",
  setting: "Configurar",
  promotion: "Promoción",
};

export default siderBar;